<template>
  <div>
    <DataTable :value="data" responsiveLayout="scroll" :scrollable="true" class="p-datatable-sm" selectionMode="single"
      :paginator="true" :rows="10" :rowsPerPageOptions="[10, 20, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" dataKey="ID" resizableColumns
      columnResizeMode="fit" ref="dataTable" showGridlines stripedRows sortMode="multiple" removableSort
      rowGroupMode="rowspan" :groupRowsBy="group_name">
      <!--columnResizeMode="expand" -->
      <template #empty> Veri Bulunamadı. </template>
      <template #loading> Yükleniyor. Lüften Bekleyin. </template>
      <Column sortable v-for="col of columns" :field="col.field" :header="col.header" :key="col.RowId">
      </Column>
      <Column v-if="editbutton" :exportable="false" style="width: 1rem">
        <template #body="slotProps">
          <Button icon="pi pi-file-edit" severity="warn" size="small" rounded @click="_edit(slotProps)" />
        </template>
      </Column>
      <Column v-if="deletebutton" :exportable="false" style="width: 1rem">
        <template #body="slotProps">
          <Button icon="pi pi-trash" severity="danger" size="small" rounded @click="_delete(slotProps)" />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>

export default {
  props: {
    columns: Array,
    data: Array,
    editbutton: Boolean,
    deletebutton: { default: true, type: Boolean },
    group_mode: { default: 'rowspan', type: String },
    group_name: String
  },
  data() {
    return {};
  },
  methods: {
    _edit(EditRowData) {
      this.$emit("set-child-data", EditRowData);
    },
    _delete(DeleteRowData) {
      this.$emit("delete-child-data", DeleteRowData);
    },
    exportCSV() {
      this.$refs.dataTable.exportCSV();
    },
  },
  mounted() {
    window.$('.p-datatable-thead').css("z-index", "0");
  }
};
</script>